<template>
    <div>
        <div class="row w-100" v-if="extras.length > 0">
            <div class="col-sm-3">
                <label class="full">Service</label>
            </div>
            <div v-if="componentRuleType !== 1" class="col-sm-2">
                <label class="full">Price</label>
            </div>
            <div class="col-sm-2">
                <label class="full">Tax</label>
            </div>
            <div v-if="componentRuleType === 1" class="col-sm-2">
                <label class="full">Percent</label>
            </div>
            <div v-if="componentRuleType === 2" class="col-sm-2">
                <label class="full">Remaining Value</label>
            </div>
            <div class="col-sm-2" v-if="componentRuleType !== 1 || componentRuleType === 2 && isPricePerGroup">
                <label class="full">PVP</label>
            </div>
            <div class="col-sm-1">
                <label class="full">&nbsp;</label>
            </div>
        </div>

        <div v-if="priceObj">
            <split-price-editor-row 
                @this-is-valid-row="rowIsValid($event)" 
                v-for="service, index in priceObj.productGenderPriceComponents" 
                :key="index"  
                :service="service" 
                :index="index" 
                @change="updateRowToStore()" 
                @removePrice="removePrice" 
                :componentRuleType="componentRuleType" 
                :disabled="disabled" 
                :isPricePerGroup="isPricePerGroup"
                @remaining-selected="onRemainingSelected"
            />
        </div>

        <div class="row d-flex justify-content-center text-center dark p-4" v-if="extras.length == 0 && !disabled">
            <span>✨ Looks like you have no services created, please create them <span class="bold underlined pointer" @click="createExtraClick">here</span>.</span>
        </div>

        <div v-else class="row mt-3 w-100">
            <div class="col-sm-12">
                <div class="add d-flex align-items-center pointer fs-small bold" v-if="!disabled" @click="addRow">
                    <i class="ico-add fs-smallest add-circle color-1"></i> Add service
                </div>
            </div>
        </div>

        <div class="error-min-height">
            <span 
                class="row d-flex justify-content-center text-center fs-small color-6" 
                v-if="componentRuleType == 1 && priceObj.productGenderPriceComponents.length > 0 && sumPercentValues != 100"
                >The sum of percent values must be 100%
            </span>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import extendedVSelect from '@/extends/vue-select'
import SplitPriceEditorRow from '@/components/inventory/products/components/SplitPriceEditorRow'

export default {
    data() {
        return {
            isValidRow: true
        }
    },
    props:{
        isToLoadUpdateRowToStore: {
            type: Boolean
        },
        disabled: {
            type: Boolean,
            default: false
        },
        isPricePerGroup: {
            type: Boolean,
            default: false
        },
        priceObj: {
            type: Object,
            default: false
        },
        componentRuleType: {
            type: Number,
            default: false
        },
    },
    watch: {
        // Whenever the pricing type changes, call updateRowToStore().
        isToLoadUpdateRowToStore: {
            deep: true,
            handler(val, oldVal) {
                if (val != oldVal) {
                    this.updateRowToStore();
                }
            }
        }
    },
    computed: {
        ...mapGetters([
            'account',
            'getProductEditPriceData',
            'getVatTypes',
            'getExtras',
        ]),
        taxes() {
            return this.getVatTypes;
        },
        extras() {
            return JSON.parse(JSON.stringify(this.getExtras));
        },
        sumPercentValues() {
            const listOfPercentValues = this.priceObj.productGenderPriceComponents.map(price => parseFloat(price.value)).filter(value => !isNaN(value));
            const sumValues = listOfPercentValues.length > 0 ? listOfPercentValues.reduce((accumulator, currentValue) => accumulator + currentValue, 0) : 0;
            
            return sumValues;
        }
    },
    methods:{
        ...mapActions([
            'openModal',
            'updateroductEditPriceData'
        ]),
        rowIsValid(rowIsValid) {
            this.$emit('row-is-ready-to-save', rowIsValid);
        },
        createExtraClick() {
            this.openModal('ExtraAdd');
        },
        removePrice(index) {
            this.priceObj.productGenderPriceComponents.splice(index, 1);

            // making this validation here to ENABLE the save button when we don't have price components [same in updateRowToStore()]
            // this will allow us to reset the price component to zero

            if (this.priceObj.componentRuleType == 0) {
                // Validation to fixed type
                const validPriceComponent = this.priceObj.productGenderPriceComponents.every( price => price.component.selectedPrice != null);

                if (validPriceComponent == true || validPriceComponent.length == 0) { 
                    this.isValidRow = true; 
                    this.$emit('row-is-ready-to-save', true);
                } else {
                    this.isValidRow = false;
                    this.$emit('row-is-ready-to-save', false);
                }
            } else if (this.priceObj.componentRuleType == 2) { 
                // Validation to open type
                const totalPrice = this.priceObj.value;
                const someServiceIsRemainingValue = this.priceObj.productGenderPriceComponents.some(price => price.isRemainingValue == true);
                const itemsRemainingValueFalse = this.priceObj.productGenderPriceComponents.filter(price => !price.isRemainingValue);
                const validPriceComponentOpenType = itemsRemainingValueFalse.every(price => price.component.selectedPrice != null ? price.component.selectedPrice.grossprice != null : false);

                if (someServiceIsRemainingValue == true && validPriceComponentOpenType && (totalPrice > 0 || this.isPricePerGroup)) { 
                    this.isValidRow = true; 
                    this.$emit('row-is-ready-to-save', true);
                } else if (this.isPricePerGroup && this.priceObj.productGenderPriceComponents.length === 0) {
                    this.isValidRow = true;
                    this.$emit('row-is-ready-to-save', true);
                } else {
                    this.isValidRow = false;
                    this.$emit('row-is-ready-to-save', false);
                }
            } else if (this.priceObj.componentRuleType == 1) { 
                // Validation to percent type
                const totalPrice = this.priceObj.value;
                const hasSomeEmptyValue = this.priceObj.productGenderPriceComponents.some(price => price.value == '' || price.value == null);
                const listOfPercentValues = this.priceObj.productGenderPriceComponents.map(price => parseFloat(price.value)).filter(value => !isNaN(value));
                const sumPercentValues = listOfPercentValues.length > 0 ? listOfPercentValues.reduce((accumulator, currentValue) => accumulator + currentValue, 0) : 0;

                if (hasSomeEmptyValue == false && sumPercentValues == 100 && totalPrice > 0) { 
                    this.isValidRow = true; 
                    this.$emit('row-is-ready-to-save', true);
                } else if (this.isPricePerGroup && this.priceObj.productGenderPriceComponents.length === 0) {
                    this.isValidRow = true;
                    this.$emit('row-is-ready-to-save', true);
                } else {
                    this.isValidRow = false;
                    this.$emit('row-is-ready-to-save', false);
                }
            }
        },
        addRow() {
            let newRow = JSON.parse(JSON.stringify(this.extras[0]));

            let defaultRow = {
                "component": newRow,
                "isMandatory": 0,
                "isRemainingValue":false,
                "valueType": this.priceObj.componentRuleType == 1 ? 1 : 0,
                "value": null,
                "vatType": newRow.vatType
            }
            
            this.priceObj.productGenderPriceComponents.push(defaultRow);
        },
        updateRowToStore() {            
            if (this.priceObj.componentRuleType == 0) {
                // Validation to fixed type
                const validPriceComponent = this.priceObj.productGenderPriceComponents.every( price => price.component.selectedPrice != null);

                if (validPriceComponent == true || validPriceComponent.length == 0) { 
                    this.isValidRow = true; 
                    this.$emit('row-is-ready-to-save', true);
                } else {
                    this.isValidRow = false;
                    this.$emit('row-is-ready-to-save', false);
                }
            } else if (this.priceObj.componentRuleType == 2) { 
                // Validation to open type
                const totalPrice = this.priceObj.value;
                const someServiceIsRemainingValue = this.priceObj.productGenderPriceComponents.some(price => price.isRemainingValue == true);
                const itemsRemainingValueFalse = this.priceObj.productGenderPriceComponents.filter(price => !price.isRemainingValue);
                const validPriceComponentOpenType = itemsRemainingValueFalse.every(price => price.component.selectedPrice != null ? price.component.selectedPrice.grossprice != null : false);

                if (someServiceIsRemainingValue == true && validPriceComponentOpenType && (totalPrice > 0 || this.isPricePerGroup)) { 
                    this.isValidRow = true; 
                    this.$emit('row-is-ready-to-save', true);
                } else if (this.isPricePerGroup && this.priceObj.productGenderPriceComponents.length === 0) {
                    this.isValidRow = true;
                    this.$emit('row-is-ready-to-save', true);
                } else {
                    this.isValidRow = false;
                    this.$emit('row-is-ready-to-save', false);
                }
            } else if (this.priceObj.componentRuleType == 1) { 
                // Validation to percent type
                const totalPrice = this.priceObj.value;
                const hasSomeEmptyValue = this.priceObj.productGenderPriceComponents.some(price => price.value == '' || price.value == null);
                const listOfPercentValues = this.priceObj.productGenderPriceComponents.map(price => parseFloat(price.value)).filter(value => !isNaN(value));
                const sumPercentValues = listOfPercentValues.length > 0 ? listOfPercentValues.reduce((accumulator, currentValue) => accumulator + currentValue, 0) : 0;

                if (hasSomeEmptyValue == false && sumPercentValues == 100 && totalPrice > 0) { 
                    this.isValidRow = true; 
                    this.$emit('row-is-ready-to-save', true);
                } else if (this.isPricePerGroup && this.priceObj.productGenderPriceComponents.length === 0) {
                    this.isValidRow = true;
                    this.$emit('row-is-ready-to-save', true);
                } else {
                    this.isValidRow = false;
                    this.$emit('row-is-ready-to-save', false);
                }
            }

            this.updateroductEditPriceData(this.priceObj);
        }

        ,
        onRemainingSelected(index, isSelected) {
            // Ensure only one remaining value is selected at a time
            if (!this.priceObj || !this.priceObj.productGenderPriceComponents) return;

            if (isSelected) {
                this.priceObj.productGenderPriceComponents.forEach((item, idx) => {
                    item.isRemainingValue = (idx === index);
                    // Update vatType for the selected item
                    if (idx === index && item.component) {
                        item.vatType = item.component.vatType;
                    }
                });
            } else {
                // If user untoggles, just set that item to false
                if (this.priceObj.productGenderPriceComponents[index]) {
                    this.priceObj.productGenderPriceComponents[index].isRemainingValue = false;
                }
            }

            // Persist changes and re-validate
            this.updateRowToStore();
        },
    },
    components: {
        vSelect: extendedVSelect,
        SplitPriceEditorRow,
    }
}
</script>

<style lang="scss" scoped>
    .error-min-height {
        min-height: 1.5rem;
    }
</style>



// WEBPACK FOOTER //
// SplitPriceEditor.vue?d61b3a9a